/**
 * "+X flere" in a tags container: tags beyond the first few are rendered with [hidden] and
 * the class tag--extra, followed by a button.tags-container__more (data-more / data-less hold
 * its two texts). Delegated, so it also works for cards rendered later by JavaScript.
 */
export function tagsMore() {
  document.addEventListener('click', function (event) {
    const button = event.target.closest('.tags-container__more');
    if (!button) return;

    const container = button.closest('.tags-container');
    const expanded = button.getAttribute('aria-expanded') === 'true';

    container.querySelectorAll('.tag--extra').forEach(function (tag) {
      tag.hidden = expanded;
    });
    button.setAttribute('aria-expanded', String(!expanded));
    button.textContent = expanded ? button.dataset.more : button.dataset.less;
  });
}

export default tagsMore;
